import cl from 'classnames';
import * as React from 'react';
import { RenderElementProps, useFocused, useSelected } from 'slate-react';
import styled from 'styled-components';

import { colorsV2 } from '../../../../colors-v2';
import { IconDeclaration } from '../types';

interface IconElementProps extends RenderElementProps {
  icon: IconDeclaration;
  size: number | string;
  selectionColor?: string;
}

const IconContainer = styled.span<{ selectionColor?: string }>`
  vertical-align: middle;
  display: inline-block;
  line-height: 1em;
  user-select: none;
  &.selected {
    background-color: ${({ selectionColor }) => selectionColor || colorsV2.primary40};
  }
`;

const IconElement = (props: IconElementProps) => {
  const focused = useFocused();
  const selected = useSelected();
  const { icon, size, children, selectionColor } = props;
  const Icon = icon.component;

  return (
    <IconContainer
      contentEditable={false}
      data-icon-key={icon.key}
      selectionColor={selectionColor}
      className={cl('icon-container', { focused, selected })}
    >
      <Icon alt={icon.key} width={size} height={size} contentEditable={false} />
      {children}
    </IconContainer>
  );
};

export default React.memo(IconElement);
